import React from 'react';

const ClientLogo = ({ logo }) => {
  return (
    <li className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6">
      {logo.url ? (
        <a 
        // href={logo.url} 
        data-ga-click="clients">
          <img src={logo.img} alt={logo.alt} />
        </a>
      ) : (
        <div className="no-link">
          <img src={logo.img} alt={logo.alt} />
        </div>
      )}
    </li>
  );
};

export default ClientLogo;
